var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_Map.js
// module id = 95
// module chunks = 0